

<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="container p">

  <div class="d-flex flex-row title-line">
    <well-page-title title="{{'signup.subscription-plan.title' | translate}}"></well-page-title>
  </div>

  <p-messages [value]="(msg | async) ?? []"></p-messages>

  <ng-container *ngIf="subscriptionTypes | async; let list">

    <div class="row ">
      <div class="col-12 col-sm-6 col-md-4" *ngFor="let subscription of list.data;let first = first">
        <well-subscription-card-view-wrapper
                                     class="subscription-type mx-xs"
                                     [subscription]="subscription"
        >
          <div class="buttons">

            @if(subscription.uuid) {
              <button pButton [label]="'signup.utils.select' | translate" type="submit"
                      (click)="onSelect(subscription.uuid)" data-testid="on-select-btn"></button>
            }
          </div>
        </well-subscription-card-view-wrapper>
      </div>
    </div>
  </ng-container>



</div>


